import { useState, useEffect } from 'react';
import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';
import { createCognitoClient } from '../../services/auth';

export const useCognito = (region: string, userPoolId?: string, clientId?: string) => {
  const [cognitoClient, setCognitoClient] = useState<CognitoIdentityProviderClient | null>(null);
  const [orgId, setOrgId] = useState<string>('');
  const [poolId, setPoolId] = useState<string | undefined>(userPoolId);
  const [appClientId, setAppClientId] = useState<string | undefined>(clientId);

  // Initialize Cognito client
  useEffect(() => {
    const client = createCognitoClient(region);
    setCognitoClient(client);
    
    // If org ID is provided, update pool ID
    if (orgId && !userPoolId) {
      setPoolId(orgId);
      // In a real app, you might have a different client ID per org
      setAppClientId(orgId); 
    }
  }, [region, userPoolId, clientId, orgId]);

  return {
    cognitoClient,
    orgId,
    setOrgId,
    poolId,
    appClientId
  };
};
